/* eslint-disable i18next/no-literal-string */
import React, { Fragment } from "react";
import { Image, Box, Title, Card, Center } from "@mantine/core";
//
import { TitleContent, GoToArticleIcon } from "./title-cont";

import type {
  LargeTextFeedCard,
  IterableInAppValues,
} from "src/typings/parentapp-feed-types";

interface LargeTextTitleProps {
  content: LargeTextFeedCard["content"];
  iterableValues: IterableInAppValues;
  hasArticle: boolean;
  isAssociatedWithPlayer: boolean;
}

export const LargeTextTitleCard: React.FC<LargeTextTitleProps> = (props) => {
  const { content } = props;

  const copyLines = props.iterableValues.mobileInboxBody.trim().split("\n");

  return (
    <Box mt="md">
      <Card shadow="sm" padding="lg" radius="md" withBorder pb="xl">
        <Card.Section fw="bold" bg={content.background.color}>
          {/* NOTE: position relative is needed here so that position: absolute below works */}
          <Box style={{ position: "relative" }}>
            {content.background.type === "IMAGE" ? (
              <Image
                src={content.background.image.url}
                alt="example"
                style={{
                  width: "100%",
                  height: "auto", // keep aspect ratio
                  display: "block",
                }}
              />
            ) : null}

            <Center
              py="xl"
              px="md"
              style={{
                position:
                  content.background.type === "IMAGE" ? "absolute" : undefined,
                top: 0,
                bottom: 0,
              }}
              bg={content.background.color ?? undefined}
            >
              <Title
                style={{ textAlign: "center" }}
                c={content.textColor}
                order={1}
              >
                {copyLines.map((txt, idx) => {
                  return (
                    <Fragment key={idx}>
                      {txt}
                      <br />
                    </Fragment>
                  );
                })}
              </Title>
            </Center>
          </Box>
        </Card.Section>

        <Card.Section pb="sm" px="sm">
          <TitleContent
            copy=""
            iconURL={props.iterableValues.mobileInboxIconURL}
            playerInitials={props.isAssociatedWithPlayer ? "AP" : ""}
          />
        </Card.Section>

        <GoToArticleIcon isVisible={props.hasArticle} />
      </Card>
    </Box>
  );
};
